import { createApi } from '@reduxjs/toolkit/query/react';
import { BackendResponse } from '../../types';
import { parseQueryParams } from '../../utils';
import { baseQueryWithReauth } from './baseQuery';
import { LogsSortByOptions } from '../../pages/TravelRequest/TravelReqDetail';

const emailConfigApi = createApi({
  reducerPath: 'emailConfig',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['EmailConfigurationFieldSet', 'Contracts'],
  endpoints: builder => ({
    createEmailConfigurationField: builder.mutation<BackendResponse<any>, any>({
      query: payload => ({
        url: `/email-configuration`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: (_, error) =>
        error ? [] : ['EmailConfigurationFieldSet'],
    }),

    getEmailConfigurationField: builder.query<
      BackendResponse<{ count: number; list: any[] }>,
      any
    >({
      query: query => {
        return {
          url: `/email-configuration${parseQueryParams(query)}`,
          method: 'GET',
        };
      },
    }),

    updateEmailConfigurationField: builder.mutation<
      BackendResponse<void>,
      { id: number; [key: string]: any }
    >({
      query: ({ id, ...rest }) => ({
        url: `/email-configuration/${id}`,
        method: 'PUT',
        body: rest,
      }),
      invalidatesTags: (_, error) =>
        error ? [] : ['EmailConfigurationFieldSet'],
    }),

    deleteEmailConfigurationField: builder.mutation<
      BackendResponse<void>,
      number[] | string[] | number | string
    >({
      query: ids => ({
        url: `/email-configuration`,
        method: 'DELETE',
        body: { ids },
      }),
      invalidatesTags: (_, error) =>
        error ? [] : ['EmailConfigurationFieldSet'],
    }),
    setDefaultEmailConfiguration: builder.mutation<
      BackendResponse<void>,
      number[] | string[] | number | string
    >({
      query: id => ({
        url: `/email-configuration/${id}/set-default`,
        method: 'PATCH',
        body: { id },
      }),
      invalidatesTags: (_, error) =>
        error ? [] : ['EmailConfigurationFieldSet'],
    }),
  }),
});

export const {
  useCreateEmailConfigurationFieldMutation,
  useDeleteEmailConfigurationFieldMutation,
  useGetEmailConfigurationFieldQuery,
  useUpdateEmailConfigurationFieldMutation,
  useSetDefaultEmailConfigurationMutation,
} = emailConfigApi;

export default emailConfigApi;
